import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsWeezeo(fromDate, toDate) {
  return () => {
    return apiCaller
      .call(api.getLogsWeezeo(fromDate, toDate))
      .then(result => {
        return result.data;
      })
      .catch(e => {
        Logger.log('dataActions: getLogsWeezeo - ', e);
        throw e;
      });
  };
}
export { getLogsWeezeo };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsWeezeo/actions.js